import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';

import { IExtraCost } from './extra-cost.types';

export interface IExtraCostFormGroupControls {
  id ?:FormControl<number | null>;
  name :FormControl<string>;
  quantity :FormControl<number>;
  unitPrice :FormControl<number>;
  lineTotal ?:FormControl<number>;
}

export class ExtraCostFormGroup extends FormGroup<IExtraCostFormGroupControls> {
  constructor(controls :IExtraCostFormGroupControls) {
    super({
      name: new FormControl<string>(''),
      quantity: new FormControl<number>(0),
      unitPrice: new FormControl<number>(0),
      lineTotal: new FormControl<number>(0),
      ...controls,
    });

    this.#initLineTotal();
  }

  #initLineTotal() :void {
    this.#updateLineTotal();

    combineLatest([
      this.controls.quantity.valueChanges,
      this.controls.unitPrice.valueChanges,
    ]).subscribe(() => this.#updateLineTotal());
  }
  #updateLineTotal() :void {
    const quantity = this.controls.quantity.value ?? 0;
    const unitPrice = this.controls.unitPrice.value ?? 0;
    const lineTotal = quantity * unitPrice;

    this.controls.lineTotal.setValue(lineTotal);
  }

  static fromData(extraCost :IExtraCost) {
    const controls :IExtraCostFormGroupControls = {
      name: new FormControl<string>(extraCost.name),
      quantity: new FormControl<number>(+extraCost.quantity),
      unitPrice: new FormControl<number>(+extraCost.unitPrice),
      lineTotal: new FormControl<number>(+extraCost.lineTotal),
    };

    if (extraCost.id) {
      controls.id = new FormControl<number>(extraCost.id);
    }

    return new ExtraCostFormGroup(controls);
  }
}
